import { Component, OnInit } from '@angular/core';
import { AttributeModel } from 'src/app/main/dynamic/model/attribute.model';

@Component({
  selector: 'app-process-header',
  templateUrl: './process-header.component.html',
  styleUrls: ['./process-header.component.scss']
})
export class ProcessHeaderComponent implements OnInit {

  politica: AttributeModel[];

  constructor() { 
  }

  ngOnInit() {
  }

}
